import * as addressConsts from '../Address/addressConsts';
import React from 'react';
import { getIn } from 'formik';
import WithWrapper from '../withWrapper/WithWrapper';
import AsyncSelect from 'react-select/async';
import Highlighter from 'react-highlight-words';
import { components } from 'react-select';
import classes from './AutoComplete.module.scss';

const AutoComplete = ({
  formik: { values, errors, touched, setFieldValue },
  id,
  name,
  placeholder,
  noOptionsMessage,
  loadOptions,
  formatOptionLabel,
  onSelect,
  onClear,
  highlightError = false,
  classNames,
  showErrorsClass,
}) => {
  const fieldKey = `${name}`;
  const errorLookup = getIn(errors, fieldKey);
  const touchLookup = getIn(touched, fieldKey);
  const errorMsgLookup = touchLookup && errorLookup && highlightError ? errorLookup : null;
  let value = getIn(values, fieldKey, '');

  if (value && value.id === addressConsts.AutocompleteAddressDoesNotExist) {
    value = '';
  }

  return (
    <div translate="no">
      <AsyncSelect
        cacheOptions
        defaultOptions
        isClearable
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          SingleValue: ({ children, data, ...props }) => (
            <components.SingleValue {...props}>{data.label}</components.SingleValue>
          ),
        }}
        noOptionsMessage={noOptionsMessage || (inputValue => `No matches found`)}
        placeholder={placeholder}
        classNamePrefix="rs"
        className={
          classes.autoCompleteContainer +
          (errorMsgLookup ? ` autoCompleteError` : '') +
          ' ' +
          (classNames?.autoComplete ?? '') +
          ' ' +
          showErrorsClass
        }
        name={name}
        id={id}
        loadOptions={(query, callback) => {
          if (query.length > 2) {
            loadOptions(query, callback);
          } else {
            callback([]);
          }
        }}
        formatOptionLabel={
          formatOptionLabel ||
          (({ label }, { inputValue }) => (
            <Highlighter searchWords={[inputValue]} textToHighlight={label || ''} />
          ))
        }
        onChange={(selectedRow, triggeredAction) => {
          if (triggeredAction.action === 'clear') {
            onClear();
          } else {
            setFieldValue(fieldKey, selectedRow);
            if (onSelect) {
              onSelect(selectedRow);
            }
          }
        }}
        value={value}
        aria-label={name}
      />
    </div>
  );
};

export default WithWrapper('asyncSelect')(AutoComplete);
